import { Contact, Layout } from '@rumblefish/ui/Rumblefish23Theme';

import { NextHeadWithMeta } from '../NextHeadWithMeta';
import { Benefits } from './Benefits';
import { deFiDevelopmentPageSeo } from './DeFiDevelopmentPage.seo';
import type { DeFiDevelopmentPageProps } from './DeFiDevelopmentPage.types';
import { DeFiServices } from './DeFiServices';
import { Faq } from './Faq';
import { Hero } from './Hero';
import { Testimonial } from './Testimonial';
import { OurWork } from './OurWork';

export const DeFiDevelopmentPage = ({
  blogPosts,
  caseStudies,
}: DeFiDevelopmentPageProps) => {
  return (
    <Layout blogPosts={blogPosts}>
      <NextHeadWithMeta {...deFiDevelopmentPageSeo} />

      <Hero />
      <DeFiServices />
      <Testimonial />
      <Benefits />
      <OurWork caseStudies={caseStudies} />
      <Faq />
      <Contact
        subtitle="We will answer any questions you may have related to DeFi Development!"
        color="orange"
      />
    </Layout>
  );
};
